export var findImagesByAttribute = function (images, attribute, value) {
    if (images === void 0) { images = []; }
    if (attribute === void 0) { attribute = ""; }
    if (value === void 0) { value = ""; }
    return images.filter(function (image) {
        var attributes = image.data.attributes;
        if (attribute in attributes) {
            var attributeValues = attributes[attribute];
            return attributeValues.values.some(function (attrValue) { return attrValue.value === value; });
        }
        return false;
    });
};
